'use client'

import { Skeleton } from '@elmnts/ui/skeleton'

/** Espelha a caixa do PreviewCard pra lista não pular quando os dados chegam. */
export function NotificationCardSkeleton() {
  return (
    <div className="rounded-lg border border-border bg-card/50 p-3">
      <div className="flex items-start gap-3">
        <Skeleton className="mt-0.5 size-4 shrink-0 rounded-full" />
        <div className="flex-1 space-y-2">
          <div className="flex items-center justify-between gap-2">
            <Skeleton className="h-4 w-2/3" />
            <Skeleton className="h-4 w-12 rounded" />
          </div>
          <Skeleton className="h-3 w-full" />
          <div className="flex items-center justify-between gap-2 pt-1">
            <Skeleton className="h-3 w-20" />
            <div className="flex gap-1">
              <Skeleton className="size-7 rounded" />
              <Skeleton className="size-7 rounded" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export function NotificationListSkeleton({ count = 4 }: { count?: number }) {
  return (
    <div className="grid gap-2">
      {Array.from({ length: count }).map((_, i) => (
        <NotificationCardSkeleton key={i} />
      ))}
    </div>
  )
}
